import React from 'react';

import * as AuditActions from 'audit/AuditActions';
import {EXPORT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import Section from 'ui-library/menus/Section';

interface GenericCanvasActionsProps {
  canvasId?: string;
}

const GenericCanvasActions = (props: GenericCanvasActionsProps): JSX.Element => {
  const {canvasId} = props;
  if (!canvasId) {
    return <></>;
  }
  return (
    <Dropdown
      menu={
        <Menu height={MenuHeight.MEDIUM} width={MenuWidth.MEDIUM}>
          <Section>
            <Option
              onSelect={() => {
                AuditActions.exportAuditLogs([canvasId]);
              }}
              dataTestAttrs={{
                component: 'GenericCanvasActions',
                element: 'exportAuditLogs',
              }}
            >
              {EXPORT_AUDIT_LOG_DISPLAY_STRING}
            </Option>
          </Section>
        </Menu>
      }
    >
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className="u-mini-spacing-left"
        icon="overflow"
        size={ButtonSize.SMALL}
        dataTestAttrs={{
          component: 'GenericCanvasActions',
          element: 'actionsButton',
        }}
      />
    </Dropdown>
  );
};

export default GenericCanvasActions;
